<template>
<div data-component="ProgressBar.vue" class="[ progress ] relative rounded-full bg-white">
	<div class="absolute rounded-full" :class="'bg-' + Color" :style="{ width: (Value / Max * 100) + '%' }"/>
</div>
</template>

<script lang="ts">
// @vuese
// Komponent odpowiedzialny za wyświetlenie paska postępu.
// @group Base Components
export default {
	name: 'ProgressBar',
	props: {
		Value: {
			type: Number,
			default: 0,
			required: true,
		},
		Max: {
			type: Number,
			default: 100,
			required: false,
		},
		Color: {
			type: String,
			default: 'accent',
			required: false,
		},
	},
};
</script>

<style lang="scss" scoped>
	.progress {
		width: 100%;
		height: 0.75rem;

		> div {
			top: 2px;
			bottom: 2px;
			left: 1px;
			max-width: calc(100% - 2px);
			transition: width 0.25s ease;
		}
	}
</style>
